import { useGameStore } from '../store/gameStore';

export const migrateLocalStorageToStore = () => {
  const { answeredQuestions, completedMonsters } = useGameStore.getState();
  
  const monsterTypes = [
    "fire", "wolf", "gas", "slippery", 
    "electric", "stair", "elbe", "pointed"
  ];

  let hasMigrated = false;
  const newAnsweredQuestions = { ...answeredQuestions };
  const newCompletedMonsters = [...completedMonsters];

  monsterTypes.forEach((type) => {
    const localStorageKey = `quiz_answered_${type}`;
    const savedData = localStorage.getItem(localStorageKey);
    
    if (savedData) {
      try {
        const answered = JSON.parse(savedData);
        if (Array.isArray(answered) && answered.length > 0) {
          newAnsweredQuestions[type] = answered;
          
          // 1문제 이상 풀면 완료된 몬스터로 간주
          if (answered.length >= 1 && !newCompletedMonsters.includes(type)) {
            newCompletedMonsters.push(type);
          }
          
          hasMigrated = true;
          
          localStorage.removeItem(localStorageKey);
        }
      } catch (error) {
        console.error(`Failed to migrate data for ${type}:`, error);
      }
    }
  });

  if (hasMigrated) {
    useGameStore.setState({
      answeredQuestions: newAnsweredQuestions,
      completedMonsters: newCompletedMonsters,
    });
    
    console.log('Successfully migrated localStorage data to Zustand store');
  }

  return hasMigrated;
};

// 앱 시작 시 마이그레이션 실행
export const initializeMigration = () => {
  const migrationCompleted = localStorage.getItem('safety-hero-migration-completed');
  
  if (!migrationCompleted) {
    const migrated = migrateLocalStorageToStore();
    if (migrated) {
      localStorage.setItem('safety-hero-migration-completed', 'true');
    }
  }
};
